<div class="card mb-3">
  <div class="card-body">
    <div class="pt-4 pb-2">
      <h5 class="card-title text-center pb-0 fs-4">
        <div><i class="bi bi-exclamation-triangle"></i></div>
        {{title}}
      </h5>
      <p class="text-center small">{{message}}</p>
    </div>

    <div class="row">
      <div class="col-6">
        <button class="btn btn-secondary w-100" (click)="dismissModal()">{{cancelText}}</button>
      </div>
      <div class="col-6">
        <button class="btn w-100" [ngClass]="confirmButtonClass" (click)="closeModal()">{{confirmText}}</button>
      </div>
    </div>

  </div>
</div>
